import { createAcl, defineAclRules } from 'vue-simple-acl';
import router from './router';

const user = JSON.parse(localStorage.getItem('_user'));

const rules = () => defineAclRules(async (setRule) => {
    setRule('is-master', (user) => user?.permissions && user?.permissions.includes('is-master'));
});

const simpleAcl = createAcl({ user, rules, router });
export default simpleAcl;
